import { Paginator } from "~/@shared/api-types/Paginator"
import { defineFetcher } from "~/api/_common/defineFetcher"
import { GET } from "~/api/_common/http"

import { Event } from "./_types"

const PATH = "/events"

type GetEventsQuery = {
  page?: number
}

type GetEvents = Paginator<OmittedEvent>

export const fetchGetEvents = defineFetcher((query: GetEventsQuery = {}): Promise<GetEvents> => {
  return GET(PATH, query)
})

type OmittedEventKey = "company_id" | "content" | "selects_by_lottery" | "event_schedules"

type OmittedEvent = Omit<Event, OmittedEventKey> & {
  number_of_applications: number
}
